import styled from "styled-components";
import WrapperContainer from "../Containers/WrapperContainer";
import { colors } from "../../consts";

export const DeviceImageContainer = styled(WrapperContainer)`
  width: 48px;
  height: 48px;

  border-radius: 8px;
  background: ${colors.ISABELLINE_DARKER};

  min-width: 48px;

  img {
    height: 75%;
  }
`;
